import React, { useEffect, useState } from 'react';
import header from '../../assets/images/Ijtimai.png';

export default function GenerateSlip() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const savedData = localStorage.getItem('temp_butcher_slip');
    if (savedData) {
      try {
        const parsed = JSON.parse(savedData);
        const finalData = Array.isArray(parsed) ? parsed : (parsed.details || [parsed]);
        setData(finalData);
      } catch (e) {
        console.error("Data parse error:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      const timer = setTimeout(() => {
        window.print();
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [data]);

  if (!data) return <div style={{ padding: '50px', textAlign: 'center' }}>Loading...</div>;

  const groupedByDay = data.reduce((groups, item) => {
    const day = item.slaughtering_day || "General";
    if (!groups[day]) groups[day] = [];
    groups[day].push(item);
    return groups;
  }, {});

  const grandTotal = data.reduce((sum, i) => sum + Number(i.total_amt || 0), 0);
  const advance = Number(data[0]?.advance || 0);
  const panelty = Number(data[0]?.panelty || data[0]?.penalty || 0);
  return (
    <div className="printable-area">
      <style>{`
        @media screen {
          body { background: #f1f5f9; margin: 0; padding: 20px; }
          .printable-area { 
            background: white; width: 210mm; margin: auto; padding: 40px; 
            box-shadow: 0 0 10px rgba(0,0,0,0.1); min-height: 297mm;
          }
        }

        @media print {
          body * { visibility: hidden !important; }
          .printable-area, .printable-area * { visibility: visible !important; }
          .printable-area { 
            position: absolute !important; left: 0; top: 0; width: 100% !important; 
            margin: 0 !important; padding: 10mm !important; display: block !important;
          }
          @page { size: A4; margin: 0; }
        }

        /* Fixed Font Sizes for Print */
        .printable-area { font-family: sans-serif; color: #000; line-height: 1.8; }
        .slip-header { text-align: center; border-bottom: 2px solid #000; margin-bottom: 15px; }
        .header-img { width: 100%; max-height: 100px; object-fit: contain; }
        
        .info-row { border: 1px solid black ;display: flex; justify-content: space-between; margin-bottom: 15px ; }
        .info-text { font-size: 18px; margin: 20px 10px; }
        
        .day-section { margin-top: 15px; page-break-inside: avoid; }
        .day-tag { background: #000; color: #fff; padding: 2px 8px; font-weight: bold; font-size: 12px; }
        
        .data-table { width: 100%; border-collapse: collapse; margin-top: 5px; }
        .data-table th, .data-table td { border: 1px solid #000; padding: 6px; text-align: left; font-size: 11px; }
        .data-table th { background: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
        
        .summary-box { margin-top: 20px; text-align: right; border: 1px solid #000; padding:20px 10px ; }
        .summary-text { font-size: 13px; margin: 2px 0; }
        .net-payable { font-size: 16px; font-weight: bold; margin-top: 5px; }
        
        .footer-container { margin-top: 50px; }
        .footer-sigs { display: flex; justify-content: space-between; margin-top: 40px; }
        .sig-line { text-align: center; width: 45%; }
        .sig-line p { margin: 0; font-size: 12px; font-weight: bold; }
      `}</style>

      <div className="slip-header">
        <img src={header} alt="header" className="header-img" />
        <h2 style={{ fontSize: '20px', fontWeight: '900', margin: '10px 0' }}>Butcher Payment Receipt</h2>
      </div>

      <div className="info-row">
        <div className=''>
          <p className="info-text px-2 py-2"><strong>Doc No :</strong> {data[0]?.doc_no}</p>
          <p className="info-text"><strong>Contact :</strong> {data[0]?.contact || 'N/A'}</p>
        </div>
        <div className=''>
          <p className="info-text px-2 py-2"><strong>Name :</strong> {data[0]?.name?.toUpperCase()}</p>
        </div>
        <div className='text-xl' style={{ textAlign: 'right' }}>
          <p className="info-text px-2 py-2"><strong>Date:</strong> {new Date().toLocaleDateString('en-GB')}</p>
          <p className="info-text"><strong>CNIC:</strong> {data[0]?.cnic || 'N/A'}</p>
        </div>
      </div>

      {Object.keys(groupedByDay).sort().map((day) => (
        <div key={day} className="day-section">
          <div className="day-tag">DAY: {day}</div>
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>Category</th>
                <th style={{ textAlign: 'center' }}>Sub Category</th>
                <th style={{ textAlign: 'center' }}>Qty</th>
                <th style={{ textAlign: 'right' }}>Rate</th>
                <th style={{ textAlign: 'right' }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {groupedByDay[day].map((item, idx) => (
                <tr key={idx}>
                  <td style={{ textAlign: 'center' }}>{item.cat_name}</td>
                  <td style={{ textAlign: 'center' }}>{item.subcat}</td>
                  <td style={{ textAlign: 'center' }}>{item.quantity}</td>
                  <td style={{ textAlign: 'right' }}>{Number(item.rate).toLocaleString()}</td>
                  <td style={{ textAlign: 'right' }}>{Number(item.total_amt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      <div className="summary-box">
        <p className="summary-text font-black pb-2">Grand Total : PKR {grandTotal.toLocaleString()}</p>
        <p className="summary-text font-black pb-2">Advance : PKR {advance.toLocaleString()}</p>
        <p className="summary-text font-black pb-2">Panelty : PKR {panelty.toLocaleString()}</p>
        <p className="net-payable">Net Payable : PKR {(grandTotal + advance - panelty).toLocaleString()}</p>
      </div>

      <div className="footer-container">
        <div className="footer-sigs mb-20" style={{ marginTop: '60px' }}>
          <div className="sig-line"><p>__________________________________________</p><p>Butcher Signature</p></div>
          <div className="sig-line"><p>__________________________________________</p><p>Secretary Signature</p></div>
        </div>
        <div className="footer-sigs" style={{ marginTop: '60px' }}>
          <div className="sig-line"><p>___________________________________________</p><p>Witness 1</p></div>
          <div className="sig-line"><p>___________________________________________</p><p>Witness 2</p></div>
        </div>
      </div>
    </div>
  );
}